export const routes = [
  { id: 1, name: "Lorem Ipsum", path: "lorem-ipsum" },
  { id: 2, name: "Dolor Sit Amet", path: "dolar-sit-amet" },
  {
    id: 3,
    name: "Consectetur adipiscing elit",
    path: "consectetur-adipiscing-elit",
  },
];
